<template>
	<div class="container">
		<div class="roleplay-container" v-if="currentCasePage">
			<div class="info-container">
				<h2>{{currentCase.title}}</h2>
				<h1>{{currentCasePage.title}}</h1>
			</div>
			<div class="script-container" v-if="component == 'Script'">
				<vue-markdown :source="description" class="markdown-container"/>
				<div v-bind:key="i" v-for="(dialogue, i) in options.dialogue">
					<p class="action">{{dialogue.action}}</p>
					<div class="sentence-container">
						<p class="sentence">{{dialogue.sentence}}</p>
					</div>
				</div>
			</div>
			<div class="image-container" v-else-if="component == 'RawMedia'">
				<img :src="media">
			</div>
			<div class="button-container">
				<p class="next-message" v-if="!atFinalPage">{{nextMessage}}</p>
				<app-button v-if="!atFinalPage" v-on:onClick="nextPage">{{$t('misc.next')}}</app-button>
				<app-button v-else v-on:onClick="finish">{{$t('misc.finish')}}</app-button>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapGetters} from 'vuex';
	import * as MutationTypes from '@/store/mutation-types';
	import {getStudentUrl} from '@/utils/UrlUtil';
	import AppButton from '@/components/app-button';
	import MediaManager from '@/media-manager';
	import VueMarkdown from 'vue-markdown';

	export default {
		components: {
			AppButton,
			VueMarkdown
		},
		mounted() {
			if (this.$gameClient == null || !this.$gameClient.isConnected || !this.$gameClient.inRoom()) {
				this.$router.push(getStudentUrl('connect'));

			}
		},
		computed: {
			...mapGetters({
				currentCase: 'getCurrentCase',
				currentPageIndex: 'getCurrentPageIndex'
			}),
			currentCasePage() {
				if (this.currentCase && this.currentCase.pages) {
					return this.currentCase.pages[this.currentPageIndex];
				} else {
					return null;
				}
			},
			component() {
				return this.currentCasePage.components.left.component;
			},
			options() {
				return this.currentCasePage.components.left.options;
			},
			media() {
				return MediaManager.getMediaUrl(this.options.media);
			},
			description() {
				return this.options.text ? this.options.text : '';
			},
			nextMessage() {
				return this.options.nextMessage || this.$t('roleplay.defaultNextMessage');
			},
			atFinalPage() {
				return this.currentCase && this.currentCase.pages && this.currentPageIndex == this.currentCase.pages.length - 1;
			}
		},
		methods: {
			nextPage() {
				this.$store.commit(MutationTypes.SET_CURRENT_PAGE_INDEX, this.currentPageIndex + 1);
			},
			finish() {
				this.$router.push(getStudentUrl('lobby'));
			}
		}
	}
</script>

<style lang="less" scoped>
	.roleplay-container {
		height: 100%;
		width: 100%;
		max-width: 800px;
		margin: auto;

		display: flex;
		flex-direction: column;
	}

	.script-container {
		flex-grow: 1;
		width: 100%;
		text-align: left;
	}

	.action {
		font-weight: bold;
	}

	.sentence-container {
		padding: 30px;
		margin-bottom: 30px;
		background: rgba(4, 148, 225, 0.25);
		font-style: italic;
		//border: solid black 1px;
	}

	.sentence {
		margin-bottom: 0px;

		&::before {
			content: "\"";
		}

		&::after {
			content: "\"";
		}
	}

	.image-container {
		flex-grow: 1;
		position: relative;

		img {
			max-height: 100%;
			max-width: 100%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}

	.button-container {
		margin: 30px 0px;
	}

	.next-message {
		font-weight: 900;
	}
</style>
